export default __webpack_public_path__ + "static/media/beaches_icon.ea127197.svg";